<template>
  <div>
    <h3 class="mb-3">卡機結帳狀態總覽</h3>


    <div class="row">
        <div class="col-4 col-md-3 py-0">
            <v-select
                v-model="filterSerialNumber"
                :items="itemsSerialNumber"
                placeholder="過濾機器序號"
                outlined
                @change="getResult()">
            </v-select>
        </div>
    </div>

    <v-data-table
      :headers="thead"
      :items="summaries"
      disable-pagination
      hide-default-footer
      :key="tableKey"
    >
      <template v-slot:item.no="{ item }">
        <span class="blue--text">{{ item.no }}</span>
      </template>

      <template v-slot:item.machine_id="{ item }">
        <v-btn
          @click="request(item)"
          :loading="item.loading"
          :disabled="item.disabled"
          color="orange"
        >確認</v-btn>
      </template>

      <template v-slot:item.cmd_code="{ item }">
        <v-text-field v-model="item.cmd_code" style="width:50px"></v-text-field>
      </template>

      <template v-slot:item.online="{ item }">
        <template v-if="item.online">
          <v-icon color="green" class="mr-3">mdi-checkbox-blank-circle</v-icon>連線
        </template>
        <template v-else>
          <v-icon color="red" class="mr-3">mdi-checkbox-blank-circle</v-icon>離線
        </template>
      </template>
    </v-data-table>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";

import settlementApi from "@/api/settlement";

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      // NOTE: v-data-table 小 bug：似乎偵測不到「內層」資料更新，暫時綁個 key 強迫 re render
      // 但若是不在第一頁會跳回來（re render）（待解）
      tableKey: Date.now(),

      filterSerialNumber: 'CCB',

      itemsSerialNumber:[
        'CCB',
        'CCA',
        'MU'
      ],

      summaries: [],

      thead: [
        {
          text: "",
          value: "no",
          align: "center"
        },
        {
          text: "確認",
          value: "machine_id",
          align: "center"
        },
        {
          text: "執行指令",
          value: "cmd_code",
          align: "center"
        },
        {
          text: "最近一筆請求時間",
          value: "latest_request_time",
          align: "center"
        },
        {
          text: "最近一筆結帳時間",
          value: "latest_settle_time",
          align: "center"
        },
        {
          text: "機器序號",
          value: "serial_number",
          align: "center"
        },
        {
          text: "機器名稱",
          value: "name",
          align: "center"
        },
        {
          text: "地址",
          value: "address",
          align: "left"
        },
        {
          text: "連線狀態",
          value: "online",
          align: "center"
        }
        // ,
        // {
        //   text: "卡機交易總金額",
        //   value: "total_amount",
        //   align: "right"
        // },
        // {
        //   text: "已結帳金額",
        //   value: "settled_amount",
        //   align: "right"
        // },
        // {
        //   text: "未結帳金額",
        //   value: "not_settled_amount",
        //   align: "right"
        // }
      ]
    };
  },

  computed: {},
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    request(item) {


      let cmd_code = parseInt(item.cmd_code);

      //50 => 結帳
      if(cmd_code >= 1 && cmd_code <= 99){

        //console.log(item)

        // this.set_snackbar({
        //   color: "success",
        //   text: "工程師測試中，稍等再試"
        // });

        item.loading = true;
        item.disabled = true;
        this.tableKey = Date.now();

        settlementApi
          .request(item.machine_id, { cmd_code: cmd_code })
          .then(res => {
            if (res.status !== 0) {
              this.set_snackbar({
                color: "error",
                text: res.message
              });
            } else {
              item.latest_request_time = res.latest_request_time;
            }

            item.loading = false;
            item.disabled = false;
            this.tableKey = Date.now();

            // 配合後端，鎖 2 分鐘內再次送出的結帳請求
            // setTimeout(() => {
            //   item.disabled = false;
            //   this.tableKey = Date.now();
            // }, 120000);
          })
          .catch(err => {});
      }
      else{
        this.set_snackbar({
          color: "error",
          text: "不合法的代碼 : "+item.cmd_code
        });
      }
    },
    getResult(){
        settlementApi
          .getSummary(this.filterSerialNumber)
          .then(res => {
            this.summaries = res.summaries;

            this.summaries.forEach((item, idx) => {
              item.no = idx + 1;

              item.loading = false;
              item.disabled = false;
            });
          })
          .catch(err => {});
    }
  },

  mounted() {
    settlementApi
      .getSummary(this.filterSerialNumber)
      .then(res => {
        this.summaries = res.summaries;

        this.summaries.forEach((item, idx) => {
          item.no = idx + 1;

          item.loading = false;
          item.disabled = false;
        });
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
